<template>
  <div>
    <v-row justify="space-between" class="mb-4" v-if="!expand">
      <v-col cols="12">
        <div class="d-flex justify-space-between flex-wrap ga-2">
          <div>
            <div class="page-title">Partner Organizations</div>
            <div class="text-subtitle-2 mt-1">
              <span class="text-grey">View and Manage Host Establishments</span>
            </div>
          </div>
          <div class="d-flex justify-end align-center">
            <v-btn
              class="white--text text-none"
              color="#00A63E"
              rounded="lg"
              elevation="0"
              @click="addnew"
              prepend-icon="mdi-plus"
            >
              Add Partner
            </v-btn>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <v-card flat class="pa-4 rounded-lg search-card">
          <div class="d-flex align-center ga-3">
            <v-text-field
              v-model="search"
              placeholder="Search partners, programs..."
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              density="compact"
              hide-details
              clearable
              class="rounded-lg"
              style="flex: 1"
            />
            <v-autocomplete
              v-model="batch_selected"
              @update:modelValue="loadBatchStudentCount"
              :items="batchList"
              item-value="id"
              :item-title="(item) => `${item.name}  (${item.year})`"
              label="Batch"
              variant="outlined"
              density="compact"
              hide-details
              class="rounded-lg"
              style="max-width: 200px"
              :color="$vuetify.theme.themes.light.inputColor"
            ></v-autocomplete>
            <v-select
              v-model="location_filter"
              :items="locationOptions"
              item-title="title"
              item-value="value"
              prepend-inner-icon="mdi-map-marker"
              variant="outlined"
              density="compact"
              hide-details
              class="rounded-lg"
              style="max-width: 160px"
            />
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="loading && !expand">
      <v-col cols="4" v-for="i in 3" :key="i">
        <v-skeleton-loader
          class="mx-auto border"
          max-width="300"
          type="image, article"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <transition name="view-switch" mode="out-in">
      <div v-if="!loading && !expand" key="grid">
        <v-row>
          <v-col cols="4" v-for="i in filteredData" :key="i.id">
            <v-card class="org-card rounded-lg" hover @click="viewDetails(i)">
              <!-- Banner -->
              <div
                class="d-flex justify-center align-center"
                :class="
                  i.hte_active ? 'org-banner-active' : 'org-banner-inactive'
                "
                style="height: 150px; position: relative"
              >
                <div class="text-h2 font-weight-bold" style="color: #b9f8cf">
                  {{ i.name[0].toUpperCase() }}
                </div>
                <v-chip
                  v-if="availableSlots(i) <= 0"
                  color="error"
                  size="small"
                  style="position: absolute; top: 12px; right: 12px"
                  >FULL</v-chip
                >
              </div>

              <!-- Content -->
              <v-card-text class="pa-4 pt-3">
                <div class="d-flex justify-space-between align-start mb-2">
                  <div class="org-name font-weight-bold">{{ i.name }}</div>
                  <v-chip
                    :color="i.hte_active ? '#008236' : 'grey'"
                    size="small"
                  >
                    {{ i.hte_active ? "Active" : "Inactive" }}
                  </v-chip>
                </div>

                <div
                  class="d-flex align-center ga-1 mb-1 text-body-2 text-grey-darken-1"
                >
                  <v-icon size="small" color="grey"
                    >mdi-map-marker-radius</v-icon
                  >
                  <span>{{ i.address }}</span>
                </div>

                <div
                  class="d-flex align-center ga-1 mb-2 text-body-2 text-grey-darken-1"
                >
                  <v-icon size="small" color="grey">mdi-account</v-icon>
                  <span>{{ i.contact_person }}</span>
                </div>

                <div
                  v-if="i.programs && i.programs.length"
                  class="d-flex align-center flex-wrap ga-1 mb-3"
                >
                  <v-icon size="small" color="grey" class="mr-1"
                    >mdi-file-document-outline</v-icon
                  >
                  <v-chip
                    v-for="p in i.programs"
                    :key="p.id"
                    size="x-small"
                    variant="tonal"
                    color="grey"
                    >{{ p.abbr }}</v-chip
                  >
                </div>

                <v-divider class="mb-3 mt-1"></v-divider>

                <div class="d-flex justify-space-between align-center">
                  <div class="d-flex align-center ga-2">
                    <div
                      class="slot-dot"
                      :style="
                        availableSlots(i) > 0
                          ? 'background-color: #22c55e'
                          : 'background-color: #ef4444'
                      "
                    ></div>
                    <span
                      class="text-body-2 font-weight-medium"
                      :style="
                        availableSlots(i) > 0
                          ? 'color: #15803d'
                          : 'color: #dc2626'
                      "
                    >
                      {{
                        availableSlots(i) > 0
                          ? `${availableSlots(i)} Slots Available`
                          : "No Slots"
                      }}
                    </span>
                  </div>
                  <div
                    class="d-flex align-center ga-1 view-details-link"
                    @click.stop="viewDetails(i)"
                  >
                    <span>View Details</span>
                    <v-icon size="small">mdi-open-in-new</v-icon>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-else-if="expand" key="detail">
        <v-row>
          <v-col cols="12" style="background-color: white; min-height: 80vh">
            <div>
              <div
                @click="expand = !expand"
                class="d-flex justify-start align-center text-subtitle-2 cursor-pointer back-link"
              >
                <div><v-icon>mdi-chevron-left</v-icon></div>
                <div>Back to List</div>
              </div>
              <div class="d-flex justify-space-between mt-6 flex-wrap ga-4">
                <div class="d-flex">
                  <div
                    class="text-h4 font-weight-bold d-flex justify-center align-center rounded-lg org-avatar"
                  >
                    {{ orgData.name[0].toUpperCase() }}
                  </div>
                  &nbsp;&nbsp;
                  <div>
                    <div class="text-h4 font-weight-bold">
                      {{ orgData.name }}
                    </div>
                    <div class="text-subtitle-2 text-grey">
                      {{ orgData.description }}
                    </div>
                  </div>
                </div>

                <div
                  class="rounded-lg d-flex justify-center align-center slots-summary-box"
                  style="width: 130px; height: 75px"
                >
                  <div class="text-center">
                    <div class="text-h5 my-2" style="color: #10b981">
                      {{ studentList.length + "/" + orgData.slots }}
                    </div>
                    <div class="text-uppercase text-subtitle-2 text-grey">
                      Available slots
                    </div>
                  </div>
                </div>
              </div>

              <div class="d-flex ga-6 mt-2 flex-wrap">
                <div style="width: 40%; min-width: 320px">
                  <div class="rounded-lg px-8 py-4 detail-panel mt-4">
                    <div class="d-flex align-center">
                      <v-avatar size="32" class="panel-icon-wrap">
                        <v-icon color="#10B981" size="18">mdi-domain</v-icon>
                      </v-avatar>
                      <div class="text-h6 ml-2">Contact Information</div>
                    </div>
                    <div class="my-3 text-grey">
                      <div class="text-caption">Contact Person</div>
                      <div class="d-flex align-center">
                        <v-icon color="grey">mdi-account</v-icon
                        >&nbsp;&nbsp;&nbsp;
                        <div class="text-subtitle-2 text-black">
                          {{ orgData.contact_person }}
                        </div>
                      </div>
                    </div>
                    <div class="my-3 text-grey">
                      <div class="text-caption">Email Address</div>
                      <div class="d-flex align-center">
                        <v-icon color="grey">mdi-email-outline</v-icon
                        >&nbsp;&nbsp;&nbsp;
                        <div class="text-subtitle-2 text-black">
                          {{ orgData.email }}
                        </div>
                      </div>
                    </div>
                    <div class="my-3 text-grey">
                      <div class="text-caption">Phone Number</div>
                      <div class="d-flex align-center">
                        <v-icon color="grey">mdi-phone</v-icon
                        >&nbsp;&nbsp;&nbsp;
                        <div class="text-subtitle-2 text-black">
                          {{ orgData.phone_no }}
                        </div>
                      </div>
                    </div>
                    <div class="my-3 text-grey">
                      <div class="text-caption">Address</div>
                      <div class="d-flex align-center">
                        <v-icon color="grey">mdi-map-marker</v-icon
                        >&nbsp;&nbsp;&nbsp;
                        <div class="text-subtitle-2 text-black">
                          {{ orgData.address }}
                        </div>
                      </div>
                    </div>
                    <div class="my-3 text-grey">
                      <div class="text-caption">Website</div>
                      <div class="d-flex align-center">
                        <v-icon color="grey">mdi-web</v-icon>&nbsp;&nbsp;&nbsp;
                        <div class="text-subtitle-2 text-black">
                          {{ orgData.website }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="rounded-lg px-8 py-5 detail-panel mt-4"
                    style="max-height: 300px; height: 300px"
                  >
                    <div class="d-flex align-center justify-space-between">
                      <div>
                        <div class="d-flex ga-1 align-center">
                          <v-avatar size="32" class="panel-icon-wrap">
                            <v-icon color="#10B981" size="18"
                              >mdi-file-outline</v-icon
                            >
                          </v-avatar>
                          <div class="text-h6 ml-2">Agreement Documents</div>
                        </div>
                        <div class="mt-2">
                          <v-btn
                            size="x-small"
                            class="text-none"
                            rounded="lg"
                            elevation="0"
                            :color="$vuetify.theme.themes.light.submitBtnsGreen"
                            @click="addAgreement"
                            >Add Agreement</v-btn
                          >
                        </div>
                      </div>
                    </div>
                    <v-divider class="mt-3"></v-divider>
                    <div style="height: 190px; overflow-y: auto" class="px-2">
                      <div v-if="agreement_list.length > 0">
                        <div
                          class="mb-3 mt-4"
                          v-for="i in agreement_list"
                          :key="i"
                        >
                          <div class="d-flex justify-space-between">
                            <div class="text-caption text-grey">
                              Agreement Type
                            </div>
                            <v-chip
                              v-if="i.agreement_type == 'moa'"
                              size="x-small"
                              color="#0d542b"
                              >MOA</v-chip
                            >
                            <v-chip
                              v-if="i.agreement_type == 'agreement'"
                              size="x-small"
                              color="#1463EC"
                              >OJT Agreement</v-chip
                            >
                          </div>
                          <div
                            class="pa-2 mt-2 rounded-lg"
                            :style="
                              i.agreement_type == 'moa'
                                ? 'border: 1px solid #b9f8cf; background-color: #f0fdf4;'
                                : 'border: 1px solid #BEDBFF; background-color: #EFF6FF;'
                            "
                          >
                            <div class="d-flex ga-2 align-center">
                              <v-icon
                                size="x-small"
                                :color="
                                  i.agreement_type == 'moa'
                                    ? '#00A63E'
                                    : '#1C39AB'
                                "
                                >mdi-file-outline</v-icon
                              >
                              <div
                                :style="
                                  i.agreement_type == 'moa'
                                    ? 'color: #0d542b'
                                    : 'color: #1C39AB'
                                "
                                class="text-subtitle-2"
                              >
                                {{ i.filename }}
                              </div>
                            </div>
                            <div
                              class="d-flex justify-space-between align-center mt-2"
                            >
                              <div>
                                <div
                                  class="text-caption"
                                  :style="
                                    i.agreement_type == 'moa'
                                      ? 'color: #0d542b'
                                      : 'color: #1C39AB'
                                  "
                                >
                                  Validity Date:
                                  {{ formatDate(i.validity_date) }}
                                </div>
                                <div
                                  class="text-caption"
                                  :style="
                                    i.agreement_type == 'moa'
                                      ? 'color: #0d542b'
                                      : 'color: #1C39AB'
                                  "
                                >
                                  Uploaded: {{ formatDate(i.createdAt) }}
                                </div>
                              </div>

                              <div class="d-flex ga-2 align-center">
                                <v-icon
                                  size="x-small"
                                  style="cursor: pointer"
                                  :color="
                                    i.agreement_type == 'moa'
                                      ? 'color: #0d542b'
                                      : 'color: #1C39AB'
                                  "
                                  @click="previewFile(i.filename)"
                                  >mdi-eye</v-icon
                                >
                                <!-- <v-icon
                                  size="x-small"
                                  style="cursor: pointer"
                                  :color="
                                    i.agreement_type == 'moa'
                                      ? 'color: #0d542b'
                                      : 'color: #1C39AB'
                                  "
                                  >mdi-download</v-icon
                                > -->
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="d-flex justify-center py-4">
                          <i class="text-caption text-grey">No data found.</i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 55%; min-width: 320px">
                  <div
                    class="rounded-lg px-10 py-5 detail-panel mt-4"
                    style="max-height: 400px"
                    :style="
                      studentList.length <= 2 ? 'height:200px' : 'height:400px'
                    "
                  >
                    <div class="d-flex align-center justify-space-between">
                      <div class="d-flex ga-1 align-center">
                        <v-avatar size="32" class="panel-icon-wrap">
                          <v-icon color="#10B981" size="18"
                            >mdi-account-multiple</v-icon
                          >
                        </v-avatar>
                        <div class="text-h6 ml-2">Interns</div>
                      </div>
                      <div style="width: 50%">
                        <v-autocomplete
                          v-model="batch_selected"
                          @update:modelValue="loadBatch"
                          :items="batchList"
                          :disabled="true"
                          item-value="id"
                          :item-title="(item) => `${item.name}  (${item.year})`"
                          variant="outlined"
                          density="compact"
                          hide-details
                          class="rounded-lg"
                          :color="$vuetify.theme.themes.light.inputColor"
                        ></v-autocomplete>
                      </div>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                    <div style="height: 290px; overflow-y: auto">
                      <div v-if="studentList.length > 0">
                        <div v-for="(i, index) in studentList" :key="index">
                          <div class="my-4 d-flex align-center">
                            <div
                              class="text-subtitle-2 d-flex justify-center align-center text-grey student-avatar"
                            >
                              {{ i.fname[0] + "" + i.lname[0] }}
                            </div>
                            <div class="ml-4">
                              <div class="text-subtitle-2 font-weight-bold">
                                {{ i.fname + " " + i.lname }}
                              </div>
                              <div class="text-caption text-grey">
                                {{ i.program.abbr }} - Deployed Date
                                {{ formatDate(i.organization_deployed_date) }}
                              </div>
                            </div>
                          </div>
                          <v-divider></v-divider>
                        </div>
                      </div>
                      <div v-else>
                        <div class="d-flex justify-center py-4">
                          <i class="text-caption text-grey">No data found.</i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="rounded-lg px-10 py-5 detail-panel mt-4"
                    style="max-height: 400px; height: 400px"
                  >
                    <div class="d-flex align-center justify-space-between">
                      <div class="d-flex ga-1 align-center">
                        <v-avatar size="32" class="panel-icon-wrap">
                          <v-icon color="#10B981" size="18"
                            >mdi-file-outline</v-icon
                          >
                        </v-avatar>
                        <div class="text-h6 ml-2">
                          Additional Documents Required for MOA Preparation
                        </div>
                      </div>
                    </div>
                    <v-divider class="mt-2"></v-divider>
                    <div style="height: 300px; overflow-y: auto" class="pa-2">
                      <div v-if="preparations_for_moa.length > 0">
                        <div
                          v-for="(i, index) in preparations_for_moa"
                          :key="index"
                        >
                          <div class="mb-3 mt-4 d-flex ga-2 align-start">
                            <v-icon
                              size="small"
                              :color="
                                i.filename == null ? '#E17100' : '#35BA66'
                              "
                              >{{
                                i.filename == null
                                  ? "mdi-alert-circle-outline"
                                  : "mdi-checkbox-marked-circle-outline"
                              }}</v-icon
                            >
                            <div style="width: 100%">
                              <div class="d-flex justify-space-between">
                                <div class="text-caption font-weight-bold">
                                  {{ i.checklist_cnt }}.

                                  {{ i.question }}
                                </div>
                              </div>
                              <div
                                v-if="i.filename != null"
                                class="pa-2 mt-2 rounded-lg"
                                style="
                                  border: 1px solid #b9f8cf;
                                  background-color: #f0fdf4;
                                "
                              >
                                <div
                                  class="d-flex justify-space-between align-center mt-2"
                                >
                                  <div
                                    class="text-caption d-flex ga-2"
                                    style="color: #0d542b"
                                  >
                                    <div><v-icon>mdi-file-outline</v-icon></div>
                                    <div
                                      class="text-truncate"
                                      style="width: 100px"
                                    >
                                      {{ i.filename }}
                                    </div>
                                  </div>
                                  <div class="d-flex ga-2 align-center">
                                    <div
                                      class="text-caption"
                                      style="color: #0d542b"
                                    >
                                      {{ formatDate(i.createdAt) }}
                                    </div>
                                    <v-icon
                                      size="x-small"
                                      style="cursor: pointer"
                                      color="#0d542b"
                                      @click="previewFile(i.filename)"
                                      >mdi-eye</v-icon
                                    >
                                    <v-icon
                                      size="x-small"
                                      style="cursor: pointer"
                                      color="#0d542b"
                                      >mdi-download</v-icon
                                    >
                                  </div>
                                </div>
                              </div>
                              <div v-else style="width: 150px">
                                <div
                                  @click="uploadFile(i)"
                                  class="upload_btn pa-2 text-caption rounded-lg font-weight-bold d-flex justify-center align-center"
                                >
                                  <v-icon color="#D87700"
                                    >mdi-tray-arrow-up</v-icon
                                  >
                                  Upload Document
                                </div>
                              </div>
                            </div>
                          </div>

                          <v-divider></v-divider>
                        </div>
                      </div>
                      <div v-else>
                        <div class="d-flex justify-center py-4">
                          <i class="text-caption text-grey">No data found.</i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </transition>

    <!-- Dialogs -->
    <OJTOrgsDialog :data="itemData" :action="action" />
    <OrgCriteriaWeightsDialog :data="viewData" />
    <ManageCredentialsDialog :data="creds" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card rounded="lg">
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            variant="text"
            class="text-none"
            @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn
            color="error"
            class="white--text text-none"
            rounded="lg"
            @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />

    <v-dialog
      v-model="agreementDialog"
      width="600"
      transition="dialog-top-transition"
    >
      <v-form ref="addFileRef" @submit.prevent>
        <v-card
          prepend-icon="mdi-upload"
          title="Upload Agreement Document"
          rounded="lg"
        >
          <v-card-text class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <div class="text-grey">Agreement Type</div>
                  <v-radio-group
                    :color="$vuetify.theme.themes.light.inputColor"
                    v-model="agreement_type"
                    inline
                  >
                    <v-radio label="MOA" value="moa"></v-radio>
                    <v-radio label="Agreement" value="agreement"></v-radio>
                  </v-radio-group>
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="selected_agreement_file"
                    :rules="[formRules.required]"
                    variant="outlined"
                    density="compact"
                    class="rounded-lg"
                    accept="application/pdf"
                    label="File input"
                  ></v-file-input>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Valid Until Date"
                    v-model="valid_until"
                    variant="outlined"
                    density="compact"
                    class="rounded-lg"
                    readonly
                    :rules="[formRules.required]"
                    @click="showDatePicker = true"
                  ></v-text-field>

                  <v-dialog v-model="showDatePicker" max-width="290">
                    <v-date-picker
                      v-model="valid_until"
                      @update:model-value="saveDate"
                      :color="$vuetify.theme.themes.light.inputColor"
                    ></v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12">
                  <v-autocomplete
                    density="compact"
                    label="Program/s Tied"
                    :rules="[formRules.arrayRequired]"
                    v-model="program_to_tie"
                    item-value="id"
                    item-title="name"
                    :color="$vuetify.theme.themes.light.inputColor"
                    variant="outlined"
                    class="rounded-lg"
                    multiple
                    clearable
                    chips
                    :items="getProgramsHandled"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="red-darken-1"
              variant="outlined"
              rounded="lg"
              class="text-none"
              @click="agreementDialog = false"
            >
              <v-icon start>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :disabled="btnLoading"
              :loading="btnLoading"
              color="#00a63e"
              class="white--text text-none"
              density="comfortable"
              variant="flat"
              rounded="lg"
              @click="save_file()"
            >
              <v-icon start>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog
      v-model="moaPreparationDialog"
      width="600"
      transition="dialog-top-transition"
    >
      <v-form ref="addFileMoaRef" @submit.prevent>
        <v-card
          prepend-icon="mdi-upload"
          title="Upload File for MOA Preparation"
          rounded="lg"
        >
          <v-card-text class="">
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-file-input
                    v-model="selected_agreement_file"
                    :rules="[formRules.required]"
                    variant="outlined"
                    density="compact"
                    class="rounded-lg"
                    accept="application/pdf"
                    label="File input"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>

          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn
              color="red-darken-1"
              variant="outlined"
              rounded="lg"
              class="text-none"
              @click="moaPreparationDialog = false"
            >
              <v-icon start>mdi-close-circle-outline</v-icon>
              Cancel
            </v-btn>
            <v-btn
              :disabled="btnLoading"
              :loading="btnLoading"
              color="#00a63e"
              class="white--text text-none"
              density="comfortable"
              variant="flat"
              rounded="lg"
              @click="save_moa_prep_file()"
            >
              <v-icon start>mdi-check-circle</v-icon>
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "@/eventBus";
import OJTOrgsDialog from "../../components/Dialogs/Forms/OJTOrgsDialog.vue";
import OrgCriteriaWeightsDialog from "../Dialogs/Forms/OrgCriteriaWeightsDialog.vue";
import ManageCredentialsDialog from "../Dialogs/Forms/Organization/ManageCredentialsDialog.vue";

export default {
  components: {
    OJTOrgsDialog,
    OrgCriteriaWeightsDialog,
    ManageCredentialsDialog,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    expand: false,
    search: "",
    location_filter: "All",
    headers: [
      { title: "Name", value: "name", align: "start" },
      { title: "Address", value: "address", align: "start" },
      //   { title: "Program Tied", value: "program_tied", align: "start" },

      {
        title: "Actions",
        value: "actions",
        align: "center",
        sortable: false,
        width: 200,
      },
    ],
    data: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    totalCount: 0,
    deleteData: null,
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    creds: null,
    orgData: null,
    dialogConfirmDelete: false,
    batchList: [],
    batch_selected: null,
    studentList: [],
    selected_agreement_file: null,
    agreement_list: [],
    preparations_for_moa: [],
    uploadedFile: null,
    agreementDialog: false,
    moaPreparationDialog: false,
    moa_prep_id: null,
    valid_until: null,
    showDatePicker: false,
    agreement_type: null,
    programsList: [],
    program_to_tie: [],
    btnLoading: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  mounted() {
    this.initialize();
    this.getBatchList();
    this.getPrograms();
    eventBus.on("closeOJTOrgsDialog", () => {
      this.initialize();
    });
    eventBus.on("closeOrgCriteriaWeightsDialog", () => {
      this.initialize();
    });
    eventBus.on("closeManageCredentialsDialog", () => {
      this.initialize();
    });
  },
  beforeUnmount() {
    eventBus.off("closeOJTOrgsDialog");
    eventBus.off("closeOrgCriteriaWeightsDialog");
    eventBus.off("closeManageCredentialsDialog");
  },
  computed: {
    locationOptions() {
      const cities = new Set();
      this.data.forEach((item) => {
        if (item.address) {
          if (item.address.toLowerCase() != "n/a") {
            cities.add(item.address);
          }
        }
      });
      return [
        { title: "All", value: "All" },
        ...Array.from(cities).map((c) => ({ title: c, value: c })),
      ];
    },
    filteredData() {
      let result = this.data;
      if (this.search) {
        const q = this.search.toLowerCase();
        result = result.filter(
          (i) =>
            i.name.toLowerCase().includes(q) ||
            (i.address && i.address.toLowerCase().includes(q)) ||
            (i.programs &&
              i.programs.some(
                (p) =>
                  p.abbr.toLowerCase().includes(q) ||
                  p.name.toLowerCase().includes(q),
              )),
        );
      }
      if (this.location_filter && this.location_filter !== "All") {
        result = result.filter(
          (i) => i.address && i.address.includes(this.location_filter),
        );
      }
      return result;
    },
    getProgramsHandled() {
      let arr = [];
      console.log("STOTE", this.$store.state.user.user);
      let handled = this.$store.state.user.user.programs_handled;
      if (this.programsList.length > 0) {
        for (let j = 0; j < handled.length; j++) {
          for (let i = 0; i < this.programsList.length; i++) {
            if (handled[j] == this.programsList[i].id) {
              arr.push(this.programsList[i]);
            }
          }
        }
      }
      return arr;
    },
  },
  methods: {
    availableSlots(item) {
      return (item.slots || 5) - (item.student_count || 0);
    },
    saveDate() {
      if (this.valid_until) {
        this.valid_until = this.formatDate3(this.valid_until);
      }
      this.showDatePicker = false;
    },
    pagination(data) {
      this.paginationData = data;
    },

    uploadFile(item) {
      this.moa_prep_id = item.id;
      this.selected_agreement_file = null;
      this.moaPreparationDialog = true;
    },
    initialize() {
      this.loading = true;
      setTimeout(() => {
        this.axiosCall(
          "/organization/tiedBy/" + this.batch_selected,
          "GET",
        ).then((res) => {
          if (res) {
            console.log("RR", res.data);
            this.data = res.data;
            this.loading = false;
          }
        });
      }, 1000);
    },
    addnew() {
      this.itemData = [{ id: null }];
      this.action = "Add";
    },

    getPrograms() {
      this.axiosCall("/program", "GET").then((res) => {
        this.programsList = res.data;
      });
    },

    // deleteItem(item) {
    //   console.log(item);
    //   this.alerted = true;
    //   // this.dialogConfirmDelete = true;
    //   // this.deleteData = item;
    // },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.viewData = item;
    },

    viewDetails(item) {
      this.expand = true;
      this.orgData = item;
      this.loadBatch();
      this.loadAgreements();
    },

    loadBatch() {
      this.axiosCall(
        "/student/getDeployedStudentByOrgAndBatch/" +
          this.orgData.id +
          "/" +
          this.batch_selected,
        "GET",
      ).then((res) => {
        this.studentList = res.data;
      });
    },

    loadBatchStudentCount() {
      console.log("CALLD", this.batch_selected);
      this.axiosCall("/organization/tiedBy/" + this.batch_selected, "GET").then(
        (res) => {
          if (res) {
            console.log(res.data);
            this.data = res.data;
            this.loading = false;
          }
        },
      );
    },

    loadAgreements() {
      this.axiosCall(
        "/organization-program-agreement/getAgreementsByOrg/" + this.orgData.id,
        "GET",
      ).then((res) => {
        console.log("AGREEMENTS", res.data);
        this.agreement_list = res.data.agreements;
        this.preparations_for_moa = res.data.preparations_for_moa;
      });
    },

    addAgreement() {
      this.selected_agreement_file = null;
      this.valid_until = null;
      this.agreement_type = null;
      this.agreementDialog = true;
    },

    async save_file() {
      let validate = await this.$refs.addFileRef.validate();
      if (validate.valid) {
        const formData = new FormData();
        let data = {
          agreement_type: this.agreement_type,
          valid_until: this.valid_until,
          organization_id: this.orgData.id,
          program_ids: this.program_to_tie,
        };
        formData.append("file", this.selected_agreement_file);
        formData.append("data", JSON.stringify(data));

        this.axiosCall(
          "/organization-program-agreement/uploadAgreement",
          "POST",
          formData,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 201) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.show = true;
            this.agreementDialog = false;
            this.loadAgreements();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.show = true;
          }
        });
      }
    },

    async save_moa_prep_file() {
      let validate = await this.$refs.addFileMoaRef.validate();
      if (validate.valid) {
        const formData = new FormData();
        let data = {
          id: this.moa_prep_id,
        };
        formData.append("file", this.selected_agreement_file);
        formData.append("data", JSON.stringify(data));

        this.axiosCall(
          "/organization-program-agreement/uploadMoaPrepById",
          "POST",
          formData,
        ).then((res) => {
          console.log(res);
          if (res.data.status == 200) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.show = true;
            this.moaPreparationDialog = false;
            this.loadAgreements();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.show = true;
          }
        });
      }
    },

    getBatchList() {
      this.axiosCall("/student/get-batch-list", "GET").then((res) => {
        this.batchList = res.data;
        this.batch_selected = this.batchList[0].id;
      });
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },

    previewFile(file) {
      let url =
        process.env.VUE_APP_SERVER +
        "/organization-program-agreement/getFile/" +
        file;
      let token = localStorage.getItem("token");
      const tab = window.open("about:blank");
      fetch(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((response) => response.blob())
        .then((blob) => {
          var _url = window.URL.createObjectURL(blob);
          tab.location = _url;
          tab.focus();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #1a1a1a;
}

.bg {
  background-color: rgb(242, 255, 240);
}
.upload_btn {
  cursor: pointer;
  background-color: #fef3c6;
  color: #d87700;
  transition: background-color 0.2s;
}
.upload_btn:hover {
  background-color: #fdbc59;
}
.search-card {
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06) !important;
}
.org-card {
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06) !important;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: pointer;
  overflow: hidden;
}
.org-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.09) !important;
  transform: translateY(-2px);
}
.org-banner-active {
  background: linear-gradient(135deg, #f0fdf4, #e6faf0);
}
.org-banner-inactive {
  background: rgb(223, 221, 221);
}
.org-name {
  font-size: 15px;
  line-height: 1.3;
  max-width: calc(100% - 70px);
}
.slot-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.view-details-link {
  color: #00a63e;
  cursor: pointer;
  font-size: 13px;
  transition: opacity 0.15s;
}
.view-details-link:hover {
  opacity: 0.7;
}

/* Detail view */
.back-link {
  color: #519043;
  font-weight: 600;
  width: fit-content;
  transition: opacity 0.15s, transform 0.15s;
}
.back-link:hover {
  opacity: 0.75;
  transform: translateX(-2px);
}
.org-avatar {
  color: #10b981;
  width: 75px;
  height: 75px;
  background-color: #10b9811a;
}
.slots-summary-box {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}
.detail-panel {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  background-color: #ffffff;
  transition: box-shadow 0.2s;
}
.detail-panel:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}
.panel-icon-wrap {
  background-color: #10b98120;
}
.student-avatar {
  width: 34px;
  height: 34px;
  border-radius: 100%;
  background-color: #e2e8f0;
}

/* View switch transition (grid <-> detail) */
.view-switch-enter-active,
.view-switch-leave-active {
  transition: opacity 0.28s ease, transform 0.28s ease;
}
.view-switch-enter-from {
  opacity: 0;
  transform: translateY(10px);
}
.view-switch-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
